export const FAQLIST_UPDATES = "FAQLIST_UPDATES";
export const FAQLIST_UPDATES_ERROR = "FAQLIST_UPDATES_ERROR";
export const FAQLIST_UPDATES_HIDE_ERROR = "FAQLIST_UPDATES_HIDE_ERROR";
export const FAQLIST_UPDATES_START_LOADER = "FAQLIST_UPDATES_START_LOADER";
export const FAQLIST_UPDATES_STOP_LOADER = "FAQLIST_UPDATES_STOP_LOADER";
